module.exports = __webpack_public_path__ + "media/application/images/instagram-7a08e3ac240944e86ff68c02f6562edb.svg";